import Link from "next/link"
import Block from "@/components/wrappers/block"
import HeadingLabel from "@/common/partials/headingLabel/headingLabel"

export default function ArticleTag({ block }) {
  return (
    <Block block={block} noStyling={true} className="article-tag">
      <Link
        href={block.attrs.tag.url}
        prefetch={false}
        className="no-underline">
        <HeadingLabel>{block.attrs.tag.label}</HeadingLabel>
      </Link>
    </Block>
  )
}
